import { ImgHTMLAttributes } from "react";

interface AppLogoProps extends ImgHTMLAttributes<HTMLImageElement> {
    size?: number | string;
    className?: string;
}

export default function AppLogo({
    size,
    width = size,
    height = size,
    className = "",
    alt = "Logo Merah",
    style,
    ...props
}: AppLogoProps) {
    return (
        <img
            src="/lambeturah.png"
            alt={alt}
            className={` ${className}`}
            {...props}
        />
    );
}
